<template>
  <reservation-notifications-table
    class="pt-hospital-tablee__withData"
    ref="table"
    :tableLabels="tableLabels"
    :tableData="tableData"
    @getTableData="getTableData"
    :totalNumber="totalNumber"
  >
    <slot />
  </reservation-notifications-table>
</template>

<script>
import reservationNotificationsTable from './index'
export default {
  name: 'pt-life-experience-pavilion__withData',
  components: {
    'reservation-notifications-table': reservationNotificationsTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    formatDateToYYYYMMDDHHMMSS (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date
        .getDate()
        .toString()
        .padStart(2, '0')
      const hours = date
        .getHours()
        .toString()
        .padStart(2, '0')
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, '0')
      const seconds = date
        .getSeconds()
        .toString()
        .padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatDateToYYYYMMDD (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date
        .getDate()
        .toString()
        .padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    setContent (item) {
      let operateText = item.type === 'CANCEL' ? '取消了 ' : '编辑了 原'
      let content = `${this.formatDateToYYYYMMDD(item.oldReservation.date)} ${
        item.oldReservation.time
      } 的预约`
      return operateText + content
    },
    getTableData (page, next) {
      let data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        },
        searchKey: this.searchKey
      }
      this.$store
        .dispatch('getReservationNotifications', data.pageable)
        .then(res => {
          let data = []
          res.data.forEach(item => {
            let obj = {}
            obj.operator = item.oldReservation.mobile
            obj.createdDate = this.formatDateToYYYYMMDDHHMMSS(item.createdDate)
            obj.content = this.setContent(item)
            obj.read = item.read
            obj.reservationId = item.reservationId
            obj.id = item.id
            data.push(obj)
          })
          this.tableData = data
          this.totalNumber = res.totalNumber
          if (next) {
            next(res.data)
          }
        })
        .catch(err => {
          this.$message.error(err || '获取生命体验馆列表失败')
        })
    }
  }
}
</script>
